import { FC } from "react";
import { Button } from "@/components/ui/button";
import {
  INTELLIGENCE_BASIC_PRICE_MODEL,
  INTELLIGENCE_DEV_PRICE_MODEL,
  INTELLIGENCE_PRICE_MODEL
} from "@/constants/user";
import { useUserStore } from "@/store/user";
import { useLocation } from "wouter";

const PLAN_LABEL_MAP: Record<string, string> = {
  [INTELLIGENCE_PRICE_MODEL]: "Professional",
  [INTELLIGENCE_DEV_PRICE_MODEL]: "Developer",
  [INTELLIGENCE_BASIC_PRICE_MODEL]: "Standard"
};

export const HeaderMyPlanButton: FC = () => {
  const [, setLocation] = useLocation();
  const currentSubscription = useUserStore((state) => state.currentSubscription);
  const pricingModel = currentSubscription?.subscription_details?.pricing_model;
  const planLabel = (pricingModel && PLAN_LABEL_MAP[pricingModel]) || "Standard";

  return (
    <Button
      className="max-lg:hidden gap-2"
      size="xs"
      variant="outline"
      onClick={() => setLocation("/ai/plans")}
    >
      My Plan
      <span className="rounded-[56px] bg-[rgba(49,121,255,0.1)] px-[8px] py-[2px] text-[12px] font-medium leading-[16px] text-[#3179ff]">
        {planLabel}
      </span>
    </Button>
  );
};
